const iso8601Regex =
  /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?([+-]\d{4}|Z))$/;

export function formatWithTimezone(iso8601DateString: string) {
  if (!iso8601Regex.test(iso8601DateString)) {
    console.error(
      `${iso8601DateString} is not a valid ISO 8601 date and time.`,
    );

    return iso8601DateString;
  }

  const timezoneOffsetString = iso8601DateString.slice(23);
  const dateString = iso8601DateString.slice(0, 19).replace("T", " ");

  const sign = timezoneOffsetString[0];

  const hours = parseInt(timezoneOffsetString.slice(1, 3), 10);
  const minutes = parseInt(timezoneOffsetString.slice(3, 5), 10);

  return `${dateString} ${sign}${hours}${minutes > 0 ? `:${minutes}` : ""} UTC`;
}
